import { clearAuthStateCookie } from '@/shared/libs/authState';
import { clearPostLoginVerificationCheck } from '@/shared/libs/post-login-verify';
import { clearOnboardingReturn } from '@/shared/libs/onboarding-return';
import { clearBillingIntent } from '@platform/billing';

/**
 * 로그아웃 시 브라우저에 남는 **사용자별 클라이언트 상태**를 전부 지운다.
 *
 * TanStack Query 캐시(`qc.clear()`)만 비우면 storage 에 남은 값이 다음 사용자에게
 * 그대로 넘어간다. 공용 PC 에서 A 가 로그아웃하고 B 가 로그인하면
 * 결제 의도(billing intent)가 남아 B 의 결제 성공 화면이 A 의 의도로 분기한다.
 *
 * ※ 조직 선택값은 정리 대상이 아니다 — 단일 소속이라 클라이언트에 보존하지 않는다.
 *
 * ⚠️ **세션 만료(onUnauthorized)에서는 호출하지 않는다.** 그건 사용자가 바뀐 게 아니라
 * 같은 사용자의 토큰이 죽은 것이라, 재로그인 후 맥락을 잃게 된다.
 * "사용자가 바뀔 수 있는 시점" = 명시적 로그아웃에서만 쓴다.
 */
export function clearClientSessionState(): void {
  clearAuthStateCookie();
  clearPostLoginVerificationCheck();
  clearOnboardingReturn();

  try {
    clearBillingIntent();
  } catch {
    // storage 접근 불가 환경(프라이빗 모드 등)은 무시 — 캐시 정리는 이미 끝났다.
  }
}
